export const MemeSound = (props: { url: string }) => {
   const audio = new Audio(props.url)

   function unlock() {
      document.removeEventListener("click", unlock)
      document.removeEventListener("keydown", unlock)
      document.removeEventListener("scroll", unlock)
      audio.load()
      audio.play().catch(err => {
         console.warn("Playback failed:", err)
      })
   }

   document.addEventListener("click", unlock)
   document.addEventListener("keydown", unlock)
   document.addEventListener("scroll", unlock)
}